"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_PATH = exports.PATHS = exports.api_prefix = void 0;
const address_1 = require("./address");
const admin_1 = require("./admin");
const client_1 = require("./client");
const cylinder_1 = require("./cylinder");
const delivery_1 = require("./delivery");
const map_1 = require("./map");
const order_1 = require("./order");
const payment_1 = require("./payment");
const pickup_1 = require("./pickup");
const product_1 = require("./product");
const quota_1 = require("./quota");
const sales_1 = require("./sales");
const shift_1 = require("./shift");
const staff_1 = require("./staff");
const supplier_1 = require("./supplier");
const supply_1 = require("./supply");
const upload_1 = require("./upload");
const wallet_1 = require("./wallet");
const port = 8080;
let BASE_URI;
let hostname;
// Separate hostname assignment to avoid ReferenceError in Node
if (typeof window !== "undefined" && window.location) {
    hostname = window.location.hostname;
}
else {
    hostname = process.env.HOSTNAME || "localhost";
}
if (hostname.includes("urbanlinegas")) {
    BASE_URI = "https://api.urbanlinegas.com";
}
else {
    BASE_URI = `http://localhost:${port}`;
}
const hubixlabUtils = "/hubixlab_utils";
const payment = "/payment";
const app = "/app";
exports.api_prefix = "api";
exports.PATHS = {
    ...client_1.ClientPath,
    ...order_1.OrderPath,
    ...admin_1.AdminPath,
    ...wallet_1.WalletPath,
    ...payment_1.PaymentPath,
    ...supply_1.SupplyPath,
    ...supplier_1.SupplierPath,
    ...quota_1.QuotaPath,
    ...product_1.ProductPath,
    ...staff_1.StaffPath,
    hubixlab_utils: hubixlabUtils,
    ...upload_1.FileUploadPath,
    ...sales_1.SalesPath,
    ...cylinder_1.CylinderPath,
    payment,
    ...pickup_1.PickupPath,
    ...shift_1.ShiftPath,
    ...map_1.MapPath,
    ...address_1.AddressPath,
    ...delivery_1.DeliveryPath,
    app,
    delivery: "/delivery",
};
const handlePath = ({ BasePath, path }) => {
    const apiPath = {
        frontend: `${exports.api_prefix}${BasePath}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
const appApi = {
    getAppData: handlePath({
        BasePath: exports.PATHS.app,
        path: "data",
    }),
};
exports.API_PATH = {
    port,
    base_uri: `${BASE_URI}/`,
    order: order_1.Order_API_PATH,
    admin: admin_1.ADMIN_API_PATH,
    client: client_1.CLIENT_API_PATH,
    auth: client_1.AUTH_API_PATH,
    wallet: wallet_1.Wallet_API_PATH,
    payment: payment_1.Payment_API_PATH,
    supply: supply_1.Supply_API_PATH,
    supplier: supplier_1.Supplier_API_PATH,
    fileUpload: upload_1.FILE_UPLOAD_API_PATH.uploadFile,
    quota: quota_1.Quota_API_PATH,
    product: product_1.Product_API_PATH,
    staff: staff_1.Staff_API_PATH,
    app: appApi,
    sales: sales_1.Sales_API_PATH,
    pickup: pickup_1.Pickup_API_PATH,
    shift: shift_1.Shift_API_PATH,
    map: map_1.Map_API_PATH,
    cylinder: cylinder_1.CYLINDER_API_PATH,
    address: address_1.Address_API_PATH,
    delivery: delivery_1.Delivery_API_PATH,
    addEmployee: handlePath({
        BasePath: exports.PATHS.app,
        path: "add_employee",
    }),
};
//# sourceMappingURL=index.js.map